module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori@2x-8e0bc17800d1dd045e4e72056514a26c.webp";